export default __webpack_public_path__ + "static/media/teleconsultation.51268e71.svg";